import { useCallback } from "react";
import { Node, useReactFlow } from "@xyflow/react";
import { onNodeClickSetter } from "@zapier/canvas-state";
import { useSetAtom } from "jotai";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";

export function useOnNodeClick(
  ref: React.MutableRefObject<HTMLDivElement | null>,
) {
  const { screenToFlowPosition, getIntersectingNodes } = useReactFlow();
  const { emitEventOnAddStep, emitEventOnAddPath } =
    useEmitUserInteractionEvents();
  const onNodeClickCommand = useSetAtom(onNodeClickSetter);

  const onNodeClick = useCallback(
    (event: React.MouseEvent, node: Node) => {
      onNodeClickCommand({
        event,
        node,
        ref,
        emitEventOnAddStep,
        emitEventOnAddPath,
        screenToFlowPosition,
        getIntersectingNodes,
      });
    },
    [
      onNodeClickCommand,
      emitEventOnAddPath,
      emitEventOnAddStep,
      getIntersectingNodes,
      ref,
      screenToFlowPosition,
    ],
  );

  return { onNodeClick };
}
